
let inject = [
  '$scope',
  'ServiceOrdersService',
  '$state',
  '$rootScope',
  'SharedService',
  '$timeout',
  'ngAuthSettings',
  'SessionService',
  'NgTableParams',
  '$uibModal'
];
class PaymentOrdersController{
  constructor ($scope,
               ServiceOrdersService,
               $state,
               $rootScope,
               SharedService,
               $timeout,
               ngAuthSettings,
               SessionService,
               NgTableParams,
               $uibModal) {

    this.$state = $state;
    this.SessionService = SessionService;
    this.ngAuthSettings = ngAuthSettings;
    this.NgTableParams = NgTableParams;
    // this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.ServiceOrdersService = ServiceOrdersService;
    this.$uibModal = $uibModal;
    this.SharedService = SharedService;

    this.serviceOrdersList = null;
    this.stateServiceOrders = {};
    this.ngTableConfigServiceOrders = null;
    this.ngTableColsServiceOrders = null;

    this.serviceOrderDetail = null;
    this.stateServiceOrderDetail = {};
    this.ngTableConfigServiceOrderDetail = null;
    this.ngTableColsServiceOrderDetail = null;

    this.wachingDetailServiceOrder = false;

    this.payment = {};
    this.payment.recaudo = 0;
    this.payment.recaudo_total = 0;
  }

  $onInit(){
    this.getServiceOrdersHead();
  }

  getServiceOrdersHead(){

    let cabeceraData = [
      {
        "number": "NCN-000024",
        "type": "Lorem Ipsum",
        "fecha_cotizacion": "2017-02-10",
        "validez_cotizacion": "2017-02-10",
        "assigned_user_name": "Lorem Ipsum",
        "valor_doc": "55680.000000",
        "valor_pendiente": "55680.000000",
        "valor_pagar_hoy": "0",
        "total": "55680.000000"
      }
    ];

    this.stateServiceOrders.loading = true;
    this.wachingDetailServiceOrder = false;
    this.$timeout(()=>{
      if(this.serviceOrdersList && this.serviceOrdersList.length > 0){
        this.stateServiceOrders.loading = false;
        this.stateServiceOrders.loaded = true;
      }else{
        //this.shCtrl.globals.currentUser.thirdDocumentNumber
        this.ServiceOrdersService.getServiceOrdersHead().then((response) => {
          this.stateServiceOrders.loading = false;
          this.stateServiceOrders.loaded = true;
          this.serviceOrdersList = response;
          this.serviceOrdersList.forEach((value, index)=>{
            value.valor_doc = parseInt(value.total);
            value.valor_pendiente = parseInt(value.total);
            value.valor_pagar_hoy = 0;
            value.valor_pagar_hoy_before = 0;
            this.payment.recaudo += value.valor_pendiente;

            value.type = "Cotización";
          })
          //this.serviceOrdersList = cabeceraData;
          console.log("cotizaciones cabecera " + JSON.stringify(response));
          this.initNgTableServiceOrders();
        }).catch((reason) => {
          this.stateServiceOrders.loading = false;
          this.stateServiceOrders.loaded = true;
          this.stateServiceOrders.error = true;
        });
      }

    }, 1000);
  }

  changeValor(row){
    let valorServiceOrder = parseInt(row.valor_pagar_hoy.replace(/,/g, ''));
    if(valorServiceOrder > row.valor_pendiente){
      row.valor_pagar_hoy = row.valor_pendiente;
      valorServiceOrder = row.valor_pendiente;
    }
    this.payment.recaudo_total -= row.valor_pagar_hoy_before;
    this.payment.recaudo_total += valorServiceOrder;

    row.valor_pagar_hoy_before = valorServiceOrder;
  }

  activateServiceOrder(row){
    if(row.activate){
      row.valor_pagar_hoy = row.valor_pendiente;
      row.valor_pagar_hoy_before = row.valor_pendiente;
      this.payment.recaudo_total += row.valor_pendiente;

    }else{
      this.payment.recaudo_total -= row.valor_pagar_hoy_before;
      row.valor_pagar_hoy = 0;
      row.valor_pagar_hoy_before = 0;
    }

  }

  initNgTableServiceOrders() {
    /**
     * name:                           "NCN-000024"
     * type:                             "Lorem Ipsum"
     * fecha_cotizacion:                 "2016-09-14"
     * validez_cotizacion:               "2016-09-14"
     * assigned_user_name:               "Lorem Ipsum"
     * valor_saldo:                      "0.0000"
     * valor_pendiente:                  "0.0000"
     * valor_pagar_hoy:                  "0.0000"
     * total:                            "0.0000"
     */
    this.ngTableColsServiceOrders = [
      {
        field: "name",
        title: "No.",
        sortable: "name",
        filter: { "name": "text" },
        show: true
      },
      {
        field: "tipo_orden",
        title: "Tipo",
        sortable: "tipo_orden",
        filter: { "tipo_orden": "text" },
        show: true
      },
      {
        field: "date_entered",
        title: "F. Creación",
        sortable: "date_entered",
        filter: { "date_entered": "date" },
        show: true
      },
      {
        field: "fecha_ejecucion",
        title: "F. Ejecución",
        sortable: "fecha_ejecucion",
        filter: { "fecha_ejecucion": "date" },
        show: true
      },
      {
        field: "assigned_user_name",
        title: "Vendedor/Ejecutivo",
        sortable: "assigned_user_name",
        filter: { "assigned_user_name": "text" },
        show: true
      },
      {
        field: "valor_doc",
        title: "Vr. Doc.",
        sortable: "valor_doc",
        filter: { "valor_doc": "text" },
        show: true
      },
      {
        field: "valor_pendiente",
        title: "Vr. Pte. x pagar",
        sortable: "valor_pendiente",
        filter: { "valor_pendiente": "text" },
        show: true
      },
      {
        field: "valor_pagar_hoy",
        title: "Vr. a pagar hoy",
        show: true
      },
      {
        field: "selection",
        title: "",
        show: true
      },
      {
        field: "total",
        title: "Saldo Doc.",
        sortable: "total",
        filter: { "total": "text" },
        show: true
      },
      {
        field: "actions",
        title: "",
        show: true
      }
    ];

    let initialParams = {
      count: 20
    };

    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.serviceOrdersList
    };

    this.ngTableConfigServiceOrders = new this.NgTableParams(initialParams, initialSettings);
  }

  getServiceOrderDetail(numberDocument){

    this.wachingDetailServiceOrder = true;
    this.stateServiceOrderDetail.loading = true;
    this.$timeout(()=>{
      this.ServiceOrdersService.getServiceOrdersDetail(numberDocument).then((response) => {
        this.stateServiceOrderDetail.loading = false;
        this.stateServiceOrderDetail.loaded = true;
        this.serviceOrderDetail = response;
        this.serviceOrderDetail.forEach((value, index) => {
          value.vr_unit = parseInt(value.vr_unit);
          value.cantidad = parseInt(value.cantidad);
          value.vr_total = parseInt(value.vr_total);
          value.descuento_moneda = parseInt(value.descuento_moneda);
          value.porcentaje_descuento = parseInt(value.porcentaje_descuento);
          value.impuestos = parseInt(value.impuestos) + "%";
        });

        console.log("cotizaciones cabecera " + JSON.stringify(response));
        this.initNgTableServiceOrderDetail();
      }).catch((reason) => {
        this.stateServiceOrderDetail.loading = false;
        this.stateServiceOrderDetail.loaded = true;
        this.stateServiceOrderDetail.error = true;
      });
    }, 1000);
  }

  initNgTableServiceOrderDetail() {
    /**
     * nombre:                     "Estufa verde a gas"
     * referencia:                 "981323"
     * cantidad:                   "5"
     * unidad_medida:              "BOLSA"
     * vr_unit:                    "0.0000"
     * descuento:                  "0.0000"
     * porcentaje_descuento:       "5%"
     * impuestos:                  "0.0000"
     * vr_total:                   "0.0000"
     */

    this.ngTableColsServiceOrderDetail = [
      {
        field: "descripcion_item",
        title: "Nombre",
        sortable: "descripcion_item",
        filter: { "descripcion_item": "text" },
        show: true
      },
      {
        field: "referencia",
        title: "Referencia",
        sortable: "referencia",
        filter: { "referencia": "text" },
        show: true
      },
      {
        field: "cantidad",
        title: "Cantidad",
        sortable: "cantidad",
        filter: { "cantidad": "text" },
        show: true
      },
      {
        field: "unidad_medida",
        title: "U.M.",
        sortable: "unidad_medida",
        filter: { "unidad_medida": "text" },
        show: true
      },
      {
        field: "vr_unit",
        title: "Vr. Unitario",
        sortable: "vr_unit",
        filter: { "vr_unit": "text" },
        show: true
      },
      {
        field: "descuento_moneda",
        title: "Vr. Descuento",
        sortable: "descuento_moneda",
        filter: { "descuento_moneda": "text" },
        show: true
      },
      {
        field: "porcentaje_descuento",
        title: "Descuento",
        sortable: "porcentaje_descuento",
        filter: { "porcentaje_descuento": "text" },
        show: true
      },
      {
        field: "impuestos",
        title: "Impuestos",
        sortable: "impuestos",
        filter: { "impuestos": "text" },
        show: true
      },
      {
        field: "vr_total",
        title: "Total",
        sortable: "vr_total",
        filter: { "vr_total": "text" },
        show: true
      }
    ];

    let initialParams = {
      count: 20
    };

    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.serviceOrderDetail
    };

    this.ngTableConfigServiceOrderDetail = new this.NgTableParams(initialParams, initialSettings);
  }
}

PaymentOrdersController.$inject = inject;

export default PaymentOrdersController;




/** WEBPACK FOOTER **
 ** ./www/components/payments-advances/payment-orders/payment-orders.controller.js
 **/